export enum StepsEnum{
  INTRO = 0,
  POLL = 1,
}
